/* ==========================================================================
   IBT — BO SUNG CHO NGAN GIO HANG   (Spec V3 muc 38, 40, 41, 42)
   Them 17.08.2026.

   Theme Halo chi co danh sach san pham + nut Checkout trong ngan gio hang.
   Spec yeu cau them:
     - khoi khuyen mai "Buy 2, Save 15%" (muc 38)
     - bang tom tat: Subtotal / Discount / Shipping FREE / Estimated Delivery /
       Estimated Total (muc 40)
     - hang tin hieu tin cay gon (muc 41)

   NGUYEN TAC: moi con so deu doc tu /cart.js cua Shopify. KHONG tu tinh giam
   gia, KHONG bia tong tien. Neu Shopify chua ap dung giam gia thi khong hien
   dong giam gia — dung muc 38 "Do not fake discount totals".

   NGAY GIAO: dung DUNG tham so cua khoi delivery_time o trang san pham
   (d_start 9, d_end 17 — theme tinh theo NGAY LICH, khong phai ngay lam viec;
   da doi chieu: trang san pham hien 26 Aug – 03 Sep voi hom nay 17 Aug).
   ========================================================================== */
(function () {
  var D_START = 9;   // giong block delivery_time tren PDP
  var D_END = 17;
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function money(cents, cart) {
    var v = (cents / 100).toFixed(2);
    var cur = (cart && cart.currency) || 'USD';
    return '$' + v + (cur !== 'USD' ? ' ' + cur : '');
  }

  function deliveryRange() {
    var a = new Date(); a.setDate(a.getDate() + D_START);
    var b = new Date(); b.setDate(b.getDate() + D_END);
    var f = function (d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); };
    return f(a) + ' – ' + f(b);
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function build(cart) {
    var qty = cart.item_count || 0;
    var discount = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      discount += d.total_allocated_amount || 0;
    });

    var promo = qty >= 2
      ? '<div class="ibt-cd__promo"><span class="ibt-cd__tag" aria-hidden="true">' + tagSvg() + '</span>' +
        '<span><strong>Buy 2, Save 15%</strong><span>Discount will be applied automatically at checkout.</span></span></div>'
      : (qty === 1
          ? '<div class="ibt-cd__promo ibt-cd__promo--nudge"><span class="ibt-cd__tag" aria-hidden="true">' + tagSvg() + '</span>' +
            '<span><strong>Add one more pajama set to save 15%</strong><span>The 15% discount applies automatically from 2 items.</span></span></div>'
          : '');

    var rows =
      '<div class="ibt-cd__row"><span>Subtotal (' + qty + (qty === 1 ? ' item' : ' items') + ')</span>' +
      '<span>' + money(cart.items_subtotal_price, cart) + '</span></div>';

    if (discount > 0) {
      rows += '<div class="ibt-cd__row ibt-cd__row--save"><span>Save 15%</span><span>-' + money(discount, cart) + '</span></div>';
    }

    rows +=
      '<div class="ibt-cd__row"><span>Shipping</span><span>FREE</span></div>' +
      '<div class="ibt-cd__note">Free US Shipping on every order</div>' +
      '<div class="ibt-cd__row"><span>Estimated Delivery</span><span>' + deliveryRange() + '</span></div>' +
      '<div class="ibt-cd__note">Made to order. Production 2–6 business days + transit 7–11 business days.</div>' +
      '<div class="ibt-cd__row ibt-cd__row--total"><span>Estimated Total</span><span>' +
      money(cart.total_price, cart) + ' ' + esc(cart.currency || 'USD') + '</span></div>';

    // Mockup ngan gio hang KHONG co hang tin hieu tin cay (da co o dai tren cung
    // cua trang va o trang san pham). Bo di de danh cho cho danh sach san pham.
    return '<div class="ibt-cd" data-ibt-cd>' + promo + '<div class="ibt-cd__summary">' + rows + '</div></div>';
  }

  /* Thanh tien do "Buy 2, Save 15%" — dat o dau ngan, dung mockup.
     Muc giam cua cua hang tinh theo SO LUONG (mua 2 tro len), khong theo so tien,
     nen thanh tien do cung do theo so luong. Khong bia nguong tien. */
  function buildBar(cart) {
    var qty = cart.item_count || 0;
    if (qty >= 2) {
      return '<div class="ibt-cdbar" data-ibt-cdbar>' +
        '<p class="ibt-cdbar__label">🎉 You unlocked 15% off!</p>' +
        '<div class="ibt-cdbar__track"><div class="ibt-cdbar__fill" style="width:100%"></div></div></div>';
    }
    return '<div class="ibt-cdbar" data-ibt-cdbar>' +
      '<p class="ibt-cdbar__label">Add 1 more pajama set to get 15% off!</p>' +
      '<div class="ibt-cdbar__track"><div class="ibt-cdbar__fill" style="width:50%"></div></div></div>';
  }

  /* Dong tuy chon cua tung san pham.
     Theme chi in TEN BIEN THE tho ("M", hoac "M / Pink" khi co nhieu tuy chon).
     Mockup muon tach thanh tung dong co nhan: "Size: M", "Color: Pink".
     Doc TEN tuy chon that tu /cart.js (options_with_values) nen khi cua hang
     them bien the MAU sau nay, dong "Color: ..." tu dong xuat hien, khong phai
     sua gi them. */
  function labelOptions(cart) {
    var rows = document.querySelectorAll('.halo-cart-sidebar .previewCartList > *');
    for (var i = 0; i < rows.length; i++) {
      var item = (cart.items || [])[i];
      var box = rows[i].querySelector('.previewCartItem-variant');
      if (!item || !box) continue;
      var opts = item.options_with_values || [];
      var html = '';
      for (var j = 0; j < opts.length; j++) {
        var n = String(opts[j].name || '').trim();
        var v = String(opts[j].value || '').trim();
        if (!v || v === 'Default Title' || n === 'Title') continue;
        html += '<span class="ibt-cd__opt"><em>' + esc(n) + ':</em> ' + esc(v) + '</span>';
      }
      if (!html) continue;
      box.setAttribute('data-ibt-opt', '');
      if (box.innerHTML !== html) { box.innerHTML = html; }
    }
  }

  function setTitle(cart) {
    var t = document.querySelector('.halo-cart-sidebar .halo-sidebar-header .title');
    if (!t) return;
    var want = 'Your Cart (' + (cart.item_count || 0) + ')';
    if (t.textContent.trim() !== want) { t.textContent = want; }
  }

  function tagSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z"/><circle cx="7.5" cy="7.5" r="1.3"/></svg>';
  }

  var busy = false;
  var observer = null;      // giu de NGAT khi chinh minh sua DOM
  var lastSig = '';         // chu ky gio hang lan ve gan nhat

  function paint(cart, host) {
    if (observer) observer.disconnect();
    try {
      var old = document.querySelector('.halo-cart-sidebar [data-ibt-cd]');
      if (old) old.remove();
      var oldBar = document.querySelector('.halo-cart-sidebar [data-ibt-cdbar]');
      if (oldBar) oldBar.remove();
      if (!cart.item_count) return;
      setTitle(cart);
      labelOptions(cart);
      host.insertAdjacentHTML('beforebegin', build(cart));
      var wrap = host.closest('.previewCart-wrapper');
      if (wrap) {
        wrap.insertAdjacentHTML('afterbegin', buildBar(cart));
        // Mockup khong co khoi "You May Also Like" xen giua san pham va bang
        // tom tat. Khong xoa (van co gia tri ban them) — chi day xuong DUOI
        // nut CHECK OUT de duong di ket thuc don khong bi ngat quang.
        var xsell = wrap.querySelector('.previewCartCollection');
        if (xsell && xsell.parentElement !== wrap) { wrap.appendChild(xsell); }
      }
    } finally {
      connect();
    }
  }

  function render(force) {
    var host = document.querySelector('.halo-cart-sidebar .previewCartAction');
    if (!host || busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sig = cart.item_count + '|' + cart.items_subtotal_price + '|' + cart.total_price;
        setTitle(cart);   // theme dung lai tieu de goc moi lan ve lai ngan
        var present = !!document.querySelector('.halo-cart-sidebar [data-ibt-cd]')
                   && !!document.querySelector('.halo-cart-sidebar [data-ibt-opt]');
        // Chi ve lai khi gio hang THAT SU doi (hoac khoi bi theme xoa mat).
        // Neu khong se ve lai lien tuc vi chinh minh lam DOM thay doi.
        if (force || sig !== lastSig || (!present && cart.item_count)) {
          lastSig = sig;
          paint(cart, host);
        }
        busy = false;
      })
      .catch(function () { busy = false; });
  }

  function connect() {
    var side = document.querySelector('.halo-cart-sidebar');
    if (!side) return;
    if (!observer) {
      observer = new MutationObserver(function () { setTimeout(render, 150); });
    }
    observer.observe(side, { childList: true, subtree: true });
  }

  // Ve lai khi: mo ngan gio hang, hoac danh sach san pham trong ngan doi
  function watch() {
    if (!document.querySelector('.halo-cart-sidebar')) return;
    render(true);
    connect();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-sidebar], .halo-cart-sidebar, a[href*="/cart"]')) {
        setTimeout(function () { render(true); }, 600);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else { watch(); }
})();
